function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 178.3l-50.8-50.8h-41.3V92H0v155.9h21.3c0 20.9 14.2 35.5 35.8 35.5 20.8 0 34.9-14.1 35.1-35.5h99.3c0 20.9 14.2 35.6 35.8 35.6 20.8 0 34.9-14.2 35.1-35.6h21.1v-69.6zM163 219.6H28.3v-99.2H163v99.2zm28.3-63.8h29.6l34.2 34.2v29.6h-63.8v-63.8zM283.5 42.5h-33.4L262.3 0l-56.7 70.9H239l-12.1 42.5z"
})));